import {
  icLightning,
  icFurniture,
  icPet,
  icAlone,
  icPool,
} from '@vivareal/lina-icons'

const QUICK_FILTERS_DEFAULT = [
  {
    filters: {
      amenities: ['FURNISHED'],
    },
    icon: icFurniture,
    text: 'Mobiliado',
  },
  {
    filters: {
      amenities: ['PETS_ALLOWED'],
    },
    icon: icPet,
    text: 'Aceita pets',
  },
  {
    filters: {
      amenities: ['BALCONY'],
    },
    icon: icAlone,
    text: 'Varanda',
  },
  {
    filters: {
      amenities: ['POOL'],
    },
    icon: icPool,
    text: 'Piscina',
  },
]

const QUICK_FILTERS = {
  RENTAL: [
    {
      filters: {
        warranties: 'zapway',
      },
      icon: icLightning,
      text: 'Sem fiador',
    },
    ...QUICK_FILTERS_DEFAULT,
  ],

  SALE: QUICK_FILTERS_DEFAULT,
}

export default QUICK_FILTERS
